import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

export const getDataDashboard = async (id,periode) => {
  const response = await axios.get(`${API_URL}/api/chart/periode/list?periode=${periode}&id_karyawan=${id}`);
  return response.data;
};